/*!

=========================================================
* Material Kit PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// Getting started - aici importi paginile care vin pe Getting Started in docs sidebar
import Tutorial from "views/Documentation/Sections/Tutorial.js";
import Styles from "views/Documentation/Sections/Styles.js";
import LintCommands from "views/Documentation/Sections/LintCommands.js";
import BuildTools from "views/Documentation/Sections/BuildTools.js";

// Components - aici importi paginile care vin pe Components in docs sidebar
import Accordion from "views/Documentation/Sections/Accordion.js";
import Badge from "views/Documentation/Sections/Badge.js";
import Buttons from "views/Documentation/Sections/Buttons.js";
import Cards from "views/Documentation/Sections/Cards.js";
import CheckboxRadioSwitch from "views/Documentation/Sections/CheckboxRadioSwitch.js";
import Clearfix from "views/Documentation/Sections/Clearfix.js";
import Dropdown from "views/Documentation/Sections/Dropdown.js";
import Footer from "views/Documentation/Sections/Footer.js";
import FileInput from "views/Documentation/Sections/FileInput.js";
import Grid from "views/Documentation/Sections/Grid.js";
import Header from "views/Documentation/Sections/Header.js";
import Icons from "views/Documentation/Sections/Icons.js";
import InfoArea from "views/Documentation/Sections/InfoArea.js";
import Inputs from "views/Documentation/Sections/Inputs.js";
import Instruction from "views/Documentation/Sections/Instruction.js";
import LinearProgress from "views/Documentation/Sections/LinearProgress.js";
import Media from "views/Documentation/Sections/Media.js";
import Modal from "views/Documentation/Sections/Modal.js";
import NavPills from "views/Documentation/Sections/NavPills.js";
import Pagination from "views/Documentation/Sections/Pagination.js";
import Parallax from "views/Documentation/Sections/Parallax.js";
import Popovers from "views/Documentation/Sections/Popovers.js";
import Select from "views/Documentation/Sections/Select.js";
import SideDots from "views/Documentation/Sections/SideDots.js";
import Snackbar from "views/Documentation/Sections/Snackbar.js";
import Table from "views/Documentation/Sections/Table.js";
import Tabs from "views/Documentation/Sections/Tabs.js";
import Tooltips from "views/Documentation/Sections/Tooltips.js";
import Typography from "views/Documentation/Sections/Typography.js";
import Upload from "views/Documentation/Sections/Upload.js";

// Plugins - aici importi paginile care vin pe Plugins in docs sidebar
import GoogleMaps from "views/Documentation/Sections/GoogleMaps.js";
import Carousel from "views/Documentation/Sections/Carousel.js";
import DateTimePicker from "views/Documentation/Sections/DateTimePicker.js";
import TagsInput from "views/Documentation/Sections/TagsInput.js";
import ImageGallery from "views/Documentation/Sections/ImageGallery.js";
import Slider from "views/Documentation/Sections/Slider.js";

const docsRoutes = [
  {
    name: "Getting started",
    path: "/documentation/tutorial",
    routes: [
      {
        path: "/documentation/tutorial",
        name: "Tutorial",
        component: Tutorial,
      },
      {
        path: "/documentation/styles",
        name: "Styles",
        component: Styles,
      },
      {
        path: "/documentation/lint-commands",
        name: "Lint Commands",
        component: LintCommands,
      },
      {
        path: "/documentation/build-tools",
        name: "Build Tools",
        component: BuildTools,
      },
    ],
  },
  {
    name: "Components",
    path: "/documentation/accordion",
    routes: [
      {
        path: "/documentation/accordion",
        name: "Accordion",
        component: Accordion,
      },
      {
        path: "/documentation/badge",
        name: "Badge",
        component: Badge,
      },
      {
        path: "/documentation/buttons",
        name: "Buttons",
        component: Buttons,
      },
      {
        path: "/documentation/cards",
        name: "Cards",
        component: Cards,
      },
      {
        path: "/documentation/checkbox-radio-switch",
        name: "Checkbox/Radio/Switch",
        component: CheckboxRadioSwitch,
      },
      {
        path: "/documentation/clearfix",
        name: "Clearfix",
        component: Clearfix,
      },
      {
        path: "/documentation/dropdown",
        name: "Dropdown",
        component: Dropdown,
      },
      {
        path: "/documentation/footer",
        name: "Footer",
        component: Footer,
      },
      {
        path: "/documentation/file-input",
        name: "File Input",
        component: FileInput,
      },
      {
        path: "/documentation/grid",
        name: "Grid",
        component: Grid,
      },
      {
        path: "/documentation/header",
        name: "Header",
        component: Header,
      },
      {
        path: "/documentation/icons",
        name: "Icons",
        component: Icons,
      },
      {
        path: "/documentation/info-area",
        name: "Info Area",
        component: InfoArea,
      },
      {
        path: "/documentation/inputs",
        name: "Inputs",
        component: Inputs,
      },
      {
        path: "/documentation/instruction",
        name: "Instruction",
        component: Instruction,
      },
      {
        path: "/documentation/linear-progress",
        name: "Linear Progress",
        component: LinearProgress,
      },
      {
        path: "/documentation/media",
        name: "Media",
        component: Media,
      },
      {
        path: "/documentation/modals",
        name: "Modal",
        component: Modal,
      },
      {
        path: "/documentation/nav-pills",
        name: "Nav Pills",
        component: NavPills,
      },
      {
        path: "/documentation/pagination",
        name: "Pagination",
        component: Pagination,
      },
      {
        path: "/documentation/parallax",
        name: "Parallax",
        component: Parallax,
      },
      {
        path: "/documentation/popovers",
        name: "Popovers",
        component: Popovers,
      },
      {
        path: "/documentation/selects",
        name: "Selects",
        component: Select,
      },
      {
        path: "/documentation/side-dots",
        name: "SideDots",
        component: SideDots,
      },
      {
        path: "/documentation/snackbar",
        name: "Snackbar",
        component: Snackbar,
      },
      {
        path: "/documentation/table",
        name: "Table",
        component: Table,
      },
      {
        path: "/documentation/tabs",
        name: "Tabs",
        component: Tabs,
      },
      {
        path: "/documentation/tooltips",
        name: "Tooltips",
        component: Tooltips,
      },
      {
        path: "/documentation/typography",
        name: "Typography",
        component: Typography,
      },
      {
        path: "/documentation/upload",
        name: "Upload",
        component: Upload,
      },
    ],
  },
  {
    name: "Plugins",
    path: "/documentation/charts",
    routes: [
      {
        path: "/documentation/google-maps",
        name: "Google Maps",
        component: GoogleMaps,
      },
      {
        path: "/documentation/carousel",
        name: "Carousel",
        component: Carousel,
      },
      {
        path: "/documentation/date-time-picker",
        name: "DateTimePicker",
        component: DateTimePicker,
      },
      {
        path: "/documentation/tags-input",
        name: "TagsInput",
        component: TagsInput,
      },
      {
        path: "/documentation/image-gallery",
        name: "ImageGallery",
        component: ImageGallery,
      },
      {
        path: "/documentation/nouislider",
        name: "Slider",
        component: Slider,
      },
    ],
  },
  { redirect: true, path: "/documentation", pathTo: "/documentation/tutorial" },
];

export default docsRoutes;
